export default __webpack_public_path__ + "static/media/photo--sm--pam2.e0a1573f.jpg";